export const FILTERS_ORDER_SETTINGS_KEY_VERSION_RESOURCES = "version-resources";

export const NO_STICKY_RIGHT = () => false;
